export const APP_ID = '1445988223';
export const SCHEME = 'dev';
export const PACKAGE = '';
